import { Component,ChangeDetectorRef, Input, OnInit,HostListener } from '@angular/core';
import { UntypedFormGroup,UntypedFormBuilder } from '@angular/forms';

import { Router } from '@angular/router';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { filter } from 'rxjs/operators';
import { ROLE_GESTOR_CONSULTA } from '../../../constantes/permissao.constants';
import { AgenteFinanceiro } from '../../../model/agente-financeiro.model';
import { TipoConteudo, TipoConsultaImpedimento } from '../../../model/arquivo.model';
import {
  ProtocoloConsultaImpedimentoArquivo, STATUS_CONSULTA_PROTOCOLO,
  StatusConsultaProtocolo, TIPO_PROTOCOLO_CONSULTA_IMPEDIMENTO
} from '../../../model/protocolo-arquivo-ipd.model';

import Utils from '../../../shared/fgi-utils';
import { PermissaoService } from '../../../shared/permissao.service';
import { AgenteFinanceiroService } from '../../../shared/services/agente-financeiro.service';
import { ProtocoloArquivoService } from '../../../shared/services/protocolo-arquivo.service';
import { ProtocoloArquivoIpdService } from '../../services/protocolo-arquivo-ipd.service';


@Component({
  selector: 'app-protocolo-pesquisar-ipd',
  templateUrl: './protocolo-pesquisar-ipd.component.html',
  styleUrl: './protocolo-pesquisar-ipd.component.scss',
  standalone: false
})
export class ProtocoloPesquisarIpdComponent implements OnInit {

    @Input() routerLinkEnvioLote?: string; // ex.: '['/operacoes/cadastro/lote']
    @Input() routerLinkEnvioLote2?: string;
    @Input() routerLinkPesquisaLote?: string;
    @Input() routerLinkCadastro?: string;
    @Input() tooltipBotaoEnvio?: string;
    @Input() textoBotaoEnvio?: string;
    @Input() textoBotaoCadastro?: string;
    @Input() tiposProtocoloIpd?: TipoConsultaImpedimento[];
    @Input() formatoArquivo?: string;


    pesquisaForm?: UntypedFormGroup;
    cnpjUsuario?: string;
    cnpjSelecionado?: string;
    statusSelecionado?: StatusConsultaProtocolo;

    pesquisado?: boolean; // usado no html
    esconderPesquisa: boolean = true;

    agentesFinanceiros: AgenteFinanceiro[] = [];
    valoresStatusProtocolo = STATUS_CONSULTA_PROTOCOLO;
    podeEscolherAgente = false;
    protocolos?: ProtocoloConsultaImpedimentoArquivo[];
    tiposProtocolo = TIPO_PROTOCOLO_CONSULTA_IMPEDIMENTO;
    public exibirComboTipoArquivo: Boolean = false;
    private rotasPermitidas: string[] = ['/operacoes/lote', '/atualizacao-informacoes/lote'];
    private atributosPaginacaoComponenteListagem?: EntityPagedResult<ProtocoloConsultaImpedimentoArquivo>;
    private opcoesPaginacao?: number[];
    private totalObjetosRetornados?: number;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private permissaoService: PermissaoService,
        private loadingService: BnLoadingService,
        private service: ProtocoloArquivoIpdService,
        private agenteService: AgenteFinanceiroService,
        private bnUsuarioService: BnUsuarioService,
        private cdref: ChangeDetectorRef,
        private router: Router
    ) {
        this.exibirComboTipoArquivo = this.rotasPermitidas.includes(this.router.url);
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.buscar(false, true)
    }

    ngOnInit(): void {

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {

            this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
        });

        this.bnUsuarioService.usuario$.pipe(
            filter(usuario => !!usuario)
        ).subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj ? usuario.cnpj : 'BNDES';
        });

        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.tiposProtocolo = TIPO_PROTOCOLO_CONSULTA_IMPEDIMENTO.filter((t) => this.tiposProtocoloIpd.includes(<TipoConsultaImpedimento>t.codigo));

        console.log(' this.tiposProtocolo', this.tiposProtocolo)

        this.pesquisado = undefined;

        this.construirFormulario();
        this.buscarAgentesFinanceiros();
    }


    private construirFormulario() {
        this.pesquisaForm = this.formBuilder.group({
            agenteFinanceiro: [''],
            statusProtocolo: [''],
            dataEnvioInicial: [''],
            dataEnvioFinal: [''],
            tipoProtocolo: null,
        });
    }

    private buscarAgentesFinanceiros() {
        this.agenteService.getAgentesFinanceirosNestaModalidade(true)
            .subscribe(agentes => {
                this.agentesFinanceiros = agentes;
            });
    }


    mudancaPagina(novaPagina: EntityPagedResult<ProtocoloConsultaImpedimentoArquivo>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar(false, false);
    }

    aposExcluirProtocolo() {
        this.buscar(false, true);
    }

    compararPorId(item1: string, item2: string): boolean {
        return (item1 && item2) ? (item1 === item2) : (!item1 && !item2);
    }

    buscar(paginaVazia: boolean, voltarPagina1: boolean) {
        this.loadingService.bloqueiaTela();
        this.esconderPesquisa = true;


        const nomeAgenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;

        if (!nomeAgenteFinanceiro && !this.cnpjUsuario) {
            return;
        }

        let agenteFinanceiro;
        if (this.podeEscolherAgente) {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
        } else {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        }

        const tipoProtocolo = this.pesquisaForm.get('tipoProtocolo').value;
        const labelStatusProtocolo = this.pesquisaForm.get('statusProtocolo')?.value;
        const statusProtocolo = STATUS_CONSULTA_PROTOCOLO.find(status => status.label === labelStatusProtocolo);
        const dataEnvioInicial: Date = this.pesquisaForm.get('dataEnvioInicial')?.value;
        const dataEnvioFinal: Date = this.pesquisaForm.get('dataEnvioFinal')?.value;

        /* preenchimento dos filtros */
        const params: any = {};

        if (agenteFinanceiro) {
            params.cnpjAgente = agenteFinanceiro.cnpj;
        }

        if (statusProtocolo) {
            params.statusProtocolo = statusProtocolo.codigo;
        }

        if (dataEnvioInicial) {
            params.dataEnvioInicial = moment(dataEnvioInicial).format('YYYYMMDD');
        }

        if (dataEnvioFinal) {
            params.dataEnvioFinal = moment(dataEnvioFinal).format('YYYYMMDD');
        }

        if (!['null', null].includes(tipoProtocolo)) {
            params.tiposProtocolos = tipoProtocolo;
        }
        else {

            params.tiposProtocolos = this.tiposProtocoloIpd?.join('&');
        }

        if(voltarPagina1){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        paginaVazia = Utils.verificaPaginaVazia(this.protocolos, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
            this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
        }
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;


        this.service.getArquivosPorAgente(params)
            .subscribe(response => {
                this.protocolos = response ? response.resultados : undefined;
                this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
                this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
                this.pesquisado = true;
                this.esconderPesquisa = false;
                this.cnpjSelecionado = agenteFinanceiro?.cnpj;
                this.loadingService.liberaTela();

                paginaVazia = Utils.verificaPaginaVazia(this.protocolos, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
                if (paginaVazia && !voltarPagina1) {
                    this.buscar(false, true);
                }
            }, err => this.loadingService.liberaTela());
    }
}
